import React, { useState } from "react";

import { getChangedData, getDefaultWidgetName } from "utils/utils";
import { FreeTextWidgetStrings, InputErrorStrings, valueStrings, WidgetStrings } from "constants/constantStrings";
import { WIDGET_TITLE_INPUT_MAXIMUM } from "constants/globalConstants";
import { WIDGET_TYPES } from "constants/widgets.type.const";

import CustomModal from "components/CustomModal";
import InputBox from "components/InputBox";
import { TextFieldValidator } from "components/InputBox/TextFieldValidator";

export default function TextWidgetForm(props) {
  const { Header, Attributes, currentLayout, setIsReportRerendering, isEdit, onWidgetAction } = props.data;

  const [openModal, setOpenModal] = useState(true);
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const [descError, setDescError] = useState(null);

  const getWidgetDefaultState = () => ({
    Header: Header || getDefaultWidgetName(),
    Attributes: {
      Text: Attributes?.Text,
      Comments: Attributes?.Comments || ""
    }
  });

  const [widgetData, setWidgetData] = useState(getWidgetDefaultState());

  const closeModal = closeType => {
    setOpenModal(false);
    props.onClose(closeType);
  };

  const titleChangeHandler = Header => {
    setWidgetData({ ...widgetData, Header });
    setIsFormInvalid(!widgetData.Attributes.Text || !Header || Header.trim().length === 0);
  };

  const textChangeHandler = FreeText => {
    setWidgetData({ ...widgetData, Attributes: { ...Attributes, Text: FreeText } });
    setIsFormInvalid(!FreeText || FreeText.trim().length === 0 || !widgetData.Header || widgetData.Header.trim().length === 0);
  };

  const getPayload = () => {
    const { Header, Attributes } = widgetData;
    const { Text,Comments } = Attributes;

    return {
      Header,
      Type: WIDGET_TYPES.FREE_TEXT,
      LayoutID: currentLayout.ID,
      Attributes: { 
        Text: Text ,
        Comments: Comments || ""
      }
    };
  };

  const onFormSubmit = async () => {
    setIsFormInvalid(true);
    let payload = {};
    if (isEdit) {
      payload = getChangedData(widgetData, getWidgetDefaultState());
      payload = { ...payload, Id: props.data.Id, LayoutID: currentLayout.ID };
    } else {
      payload = getPayload();
      onWidgetAction("ADD_WIDGET", payload);
    }

    setIsFormInvalid(false);
    closeModal(payload);
  };

  const onDescrtiptionMaxLimitReached = maxLength => {
    setDescError(InputErrorStrings.maxlimitis + maxLength);
  };

  return (
    <>
      {openModal && (
        <CustomModal
          show={openModal}
          title={isEdit ? FreeTextWidgetStrings.editTitle : FreeTextWidgetStrings.addTitle}
          confirmBtnText={isEdit ? WidgetStrings.editWidget : WidgetStrings.addWidget}
          description={FreeTextWidgetStrings.description}
          secondaryDescription={valueStrings.mandatoryField}
          close={closeModal}
          confirmBtnAction={onFormSubmit}
          confirmDisabled={isFormInvalid}
        >
          <div className="widget-form-container">
            <div className="form-group">
              <label className="bodyMainHeadingText" htmlFor="widgetTitle">
                {WidgetStrings.widgetTitle}*
              </label>
              <InputBox
                name="widgetTitle"
                value={widgetData.Header}
                placeholder={WidgetStrings.titlePlaceholder}
                onChange={titleChangeHandler}
                validator={TextFieldValidator.ALPHANUMERIC_WITH_SPECIAL_CHARS}
                maxLength={WIDGET_TITLE_INPUT_MAXIMUM}
              />
            </div>

            <div className="form-group">
              <label className="bodyMainHeadingText" htmlFor="freeText">
                {FreeTextWidgetStrings.freeText}*
              </label>
              <InputBox
                name="freeText"
                value={widgetData.Attributes.Text}
                placeholder={WidgetStrings.typeHere}
                onChange={textChangeHandler}
                rows="10"
                maxLength={100}
                onMaxLengthReached={onDescrtiptionMaxLimitReached}
                errorMsg={descError}
              />
            </div>
          </div>
        </CustomModal>
      )}
    </>
  );
}
